import { Injectable } from '@angular/core';

import { IPostSyncAzureActiveDirectoryCommandShapes, IPostSyncAzureActiveDirectoryRequest, IPostSyncAzureActiveDirectoryResponse } from 'fa-kt.types';
import { PostCommandService } from 'pbc.angular';

@Injectable({
  providedIn: 'root',
})
export class PostSyncAzureActiveDirectoryCommandService extends PostCommandService<
  IPostSyncAzureActiveDirectoryRequest,
  IPostSyncAzureActiveDirectoryResponse,
  IPostSyncAzureActiveDirectoryCommandShapes
> {
  readonly route = 'personen/sync-azure-active-directory';
}
